// Close a popup
function closePopup(selector) {
    if ($(selector).length) {
        $(selector).find('.close').click();
    } else if ($('#popup-' + selector).length) {
        $('#popup-' + selector).find('.close').click();
    }
}

export {closePopup}